module.exports = __webpack_public_path__ + "static/media/ZainarWifiNew3.7d829316.png";